import { CARE_PILLARS } from '../constants';

function CareSection() {
  const n = CARE_PILLARS.length;
  const cols =
    n === 1 ? 'lg:grid-cols-1'
    : n === 2 ? 'lg:grid-cols-2'
    : n >= 4 ? 'lg:grid-cols-4'
    : 'lg:grid-cols-3';
  return (
    <section id="care" className="bg-petal/60">
      <div className="mx-auto max-w-6xl px-6 py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-black uppercase tracking-[0.22em] text-rose">
            Profile details
          </p>
          <h2 className="font-display mt-3 text-4xl text-plum sm:text-5xl">
            Information, presented clearly.
          </h2>
          <p className="mt-5 leading-8 text-ink/70">
            This directory page brings together the public details available
            for this organization in one calm, easy-to-read place.
          </p>
        </div>

        <div className={`mt-14 grid gap-5 md:grid-cols-2 ${cols}`}>
          {CARE_PILLARS.map((pillar) => (
            <article
              key={pillar.title}
              className="group flex h-full flex-col rounded-3xl border border-line/80 bg-white p-7 transition hover:-translate-y-1 hover:border-rose/50 hover:shadow-soft"
            >
              <span
                aria-hidden
                className="font-display grid h-12 w-12 place-items-center rounded-full bg-plum text-2xl text-petal transition group-hover:bg-rose"
              >
                {pillar.icon}
              </span>
              <h3 className="font-display mt-6 text-2xl text-plum">{pillar.title}</h3>
              <p className="mt-3 leading-7 text-ink/70">{pillar.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CareSection;
